import moment from 'moment';
import { getProjects, getProjectsLight } from '../../HttpRequests/projects';
import { loadProjects } from '../State/projects';

let lastGetTimestamp = null;

const cacheTTL = 60000;

export default ({ force, loadClientId } = {}) => async (dispatch) => {

  try {

    if (!force && lastGetTimestamp) {

      const now = Number(moment().format('x'));

      if (now < (lastGetTimestamp + cacheTTL)) return;
    }

    lastGetTimestamp = Number(moment().format('x'));

    /*const params = {
      'fields[projects]': ['id', 'client_site_id', 'status_key'].join(),
      pagination: 0,
      include: 'clientSite.client',
      append: ['client_name', 'client_site_name'].join()
    }*/

      //'clientSite.client', 'orders'
    const params = {
     'fields[projects]': ['id', 'client_site_id', 'status_key'].join(),
      pagination: 0,
      include: ['clientSite.client'],
    }

    if (loadClientId > 0)
        params['filter[client_id]'] = loadClientId;

    params['filter[status_key]'] = [1,2];

    const response = await getProjectsLight({ params });

    dispatch(loadProjects(response.data.data));

  } catch (error) {

    throw error;

  }
}
